// extracted by mini-css-extract-plugin
export default {"actions-user-buttons":"OrganizationDataForm_actions-user-buttons__SFvaL","action-button":"OrganizationDataForm_action-button__kItlh"};